import React from "react";
import { Loader } from "semantic-ui-react";

export const Loading = (WrappedComponent) => {
  const Wrapper = (props) => {
    if (props.loading) {
      return <Loader active />;
    }

    return <WrappedComponent {...props} />;
  };

  return Wrapper;
};
